// My players' news beside the lineup (B-316, DIRECTION U21): the News
// screen's Mine, newest first, with Older for the rest. The league's other
// filters are on the News screen, a tap away at the panel's head.

import { useNews, useReaderZone } from '../../data/hooks';
import { EmptyState } from '../../kit';
import { Button } from '../../kit/ui';
import { NewsRow } from '../NewsScreen';
import { FromLeague } from '../shared/FromLeague';
import '../../styles/screens/news.css';

export function NewsPanel() {
  const feed = useNews('mine');
  const zone = useReaderZone();
  return (
    <FromLeague snapshot={feed.snapshot}>
      {(items) =>
        items.length === 0 ? (
          <EmptyState>Quiet week. No news on your roster.</EmptyState>
        ) : (
          <div className="fsp-side-list">
            {items.map((n) => (
              <NewsRow key={n.id} n={n} zone={zone} />
            ))}
            {feed.older !== null || feed.loadingOlder ? (
              <div className="fsp-side-more">
                <Button
                  size="xs"
                  variant="quiet"
                  disabled={feed.loadingOlder}
                  onClick={() => feed.older?.()}
                >
                  {feed.loadingOlder ? 'Reading…' : 'Older'}
                </Button>
              </div>
            ) : null}
          </div>
        )
      }
    </FromLeague>
  );
}
